var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouthOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-493 15295)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(527 -15295)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.045,3.832a3.681,3.681,0,0,1,.46,0,5.95,5.95,0,0,0,3.031-.5,31.036,31.036,0,0,0,3.9-2.1A15.435,15.435,0,0,1,8.994.385a4.651,4.651,0,0,1,3.769.029,6.311,6.311,0,0,0,.989.331A2.524,2.524,0,0,0,15.379.51a4.936,4.936,0,0,1,4.706.214c1.1.618,2.184,1.272,3.289,1.885a9.258,9.258,0,0,0,3.073,1.152c.442.068.9.062,1.345.091a2.717,2.717,0,0,1,.64.1c-.157.108-.308.228-.473.322a8.915,8.915,0,0,0-2.2,1.921c-.905,1.011-1.783,2.047-2.71,3.037a9.821,9.821,0,0,1-5.263,3.105,19.814,19.814,0,0,1-4.184.319A12.617,12.617,0,0,1,9.534,12,10.646,10.646,0,0,1,4.973,8.8c-.774-.9-1.53-1.81-2.328-2.685A12.672,12.672,0,0,0,.318,4.2,2.688,2.688,0,0,1,0,3.9l.045-.072",
    transform: "translate(496 -15284)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthOn);
export default __webpack_public_path__ + "static/media/mouthON.d6e9b600e28a0dd7a7ca9ed3c780d88b.svg";
export { ForwardRef as ReactComponent };